export const TimeFormatMixin = {
  methods: {
    formatTime(timestamp, format='H:i') {
        var time
        if (isNaN(timestamp))
            time = new Date(timestamp)
        else
            time = new Date(timestamp * 1000)

        if (format.indexOf('H') != -1) 
            format = format.replace('H', this.leadingZeros(time.getHours(), 2))
        if (format.indexOf('i') != -1) 
            format = format.replace('i', this.leadingZeros(time.getMinutes(), 2))
        if (format.indexOf('Y') != -1) 
            format = format.replace('Y', this.leadingZeros(time.getFullYear(), 4))
        if (format.indexOf('m') != -1) 
            format = format.replace('m', this.leadingZeros(time.getMonth() + 1, 2))
        if (format.indexOf('d') != -1) 
            format = format.replace('d', this.leadingZeros(time.getDate(), 2))
        
        return format
    },
    leadingZeros(value, length) {
        var string = '0' + value
        return string.substring(string.length - length)
    }
  },
}